import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import FormContext from './FormContext';

export default class Form extends PureComponent {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
    className: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    validationErrors: PropTypes.object,
    afterFieldValidated: PropTypes.func,
  };

  static defaultProps = {
    validationErrors: {},
  };

  state = {
    formData: {},
    validationErrors: this.props.validationErrors,
    shouldRunValidators: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!Object.keys(prevState.validationErrors).length && nextProps.validationErrors) {
      return {
        validationErrors: nextProps.validationErrors,
      };
    }
    return null;
  }

  componentDidUpdate() {
    if (!this.state.shouldRunValidators) {
      return;
    }

    const isEveryFieldValidated = Object.keys(this.state.formData).length === Object.keys(this.validatedFields).length;

    if (!isEveryFieldValidated) {
      return;
    }

    if (Object.values(this.validatedFields).every(Boolean)) {
      this.validatedFields = {};
      this.sendForm();
    }

    this.setState({ shouldRunValidators: false }); // eslint-disable-line react/no-did-update-set-state
  }

  validatedFields = {};

  clear = (fieldNames = Object.keys(this.state.formData)) => {
    const newFormData = fieldNames.reduce((obj, fieldName) => ({ ...obj, [fieldName]: '' }), {});

    this.setState(prevState => ({
      formData: { ...prevState.formData, ...newFormData },
    }));
  };

  sendForm = () => {
    this.setState({ requestInProgress: true });
    this.props.onSubmit(this.state.formData).then((wasRequestSuccessful) => {
      this.setState({ requestInProgress: false, validationErrors: {}, wasRequestSuccessful });
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.validateForm();
  };

  validateForm = () => {
    this.setState({ shouldRunValidators: true });
  };

  fieldChanged = (name, value) => {
    this.setState(prevState => ({
      formData: { ...prevState.formData, [name]: value },
    }));
  };

  fieldValidated = (name, inputProps) => {
    const { errorMessage } = inputProps;
    const { afterFieldValidated } = this.props;
    const isValid = !errorMessage;

    this.setState(prevState => ({
      validationErrors: {
        ...prevState.validationErrors,
        [name]: errorMessage,
      },
    }));

    this.validatedFields[name] = isValid;

    if (typeof afterFieldValidated === 'function') {
      afterFieldValidated(name, isValid);
    }
  };

  registerField = (field, value) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  };

  render() {
    const { className } = this.props;

    const formParams = {
      formData: this.state.formData,
      onChange: this.fieldChanged,
      onValidate: this.fieldValidated,
      validationErrors: this.state.validationErrors,
      registerField: this.registerField,
      requestInProgress: this.state.requestInProgress,
      wasRequestSuccessful: this.state.wasRequestSuccessful,
      shouldRunValidators: this.state.shouldRunValidators,
    };

    return (
      <form
        className={className}
        onSubmit={this.handleSubmit}
        method="post"
      >
        <FormContext.Provider value={formParams}>
          {this.props.children}
        </FormContext.Provider>
      </form>
    );
  }
}
